import BaseAttribute from './baseAttribute';
import { Category, Resources } from '../character/allValues';
import ValueAttribute from './valueAttribute';

export default class Resource extends ValueAttribute {
  public category: Category = Category.Resource;

  public constructor(name: string) {
    super(name);

    switch (name) {
      case Resources.lep:
        this.abbreviation = 'lep';
        break;
      case Resources.ini:
        this.abbreviation = 'ini';
        break;
      case Resources.aip:
        this.abbreviation = 'aip';
        break;
      case Resources.ep:
        this.abbreviation = 'ep';
        break;
      case Resources.wap:
        this.abbreviation = 'wap';
        break;
      case Resources.myp:
        this.abbreviation = 'myp';
        break;
      case Resources.hp:
        this.abbreviation = 'hp';
        break;

      // Nothing to do in any other case
      default:
        break;
    }
  }

  public getClone() {
    const clone = new Resource(this.name);
    clone.value = this.value;
    clone.category = this.category;
    return clone;
  }
}
